import { QueryOptions, Where } from "src/app/helpers/QueryOptions";
import { eQuestionStatus } from "src/app/models/eQuestionStatus";

export class QuestionFilterFields {
    textInput! : string|null;
    status! : eQuestionStatus|null;

    constructor(textInput:string|null, type:eQuestionStatus|null) {
        this.textInput = textInput;
        this.status = type;
    }

    /**
     * El filtro por status no se puede hacer con un where normal de MiaQuery así que acá adjunto una variable más a QueryOptions y lo trato como any para que no reviente el typescript
     */
    to_Not_QueryOptions(qo:QueryOptions) : any {
        let qo_any : any = qo;
        
		if (this.textInput)
			qo_any.search = this.textInput;

		if (this.status != null && this.status != undefined)
			qo_any.filter_type = this.status;

		return qo_any;
	}
}